import { render, staticRenderFns } from "./StandardKeyboard.vue?vue&type=template&id=a756be92&"
import script from "./StandardKeyboard.vue?vue&type=script&lang=js&"
export * from "./StandardKeyboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports